import { render } from "./FormWizard.vue?vue&type=template&id=c45bda9a"
import script from "./FormWizard.vue?vue&type=script&lang=js"
export * from "./FormWizard.vue?vue&type=script&lang=js"

import "./FormWizard.vue?vue&type=style&index=0&id=c45bda9a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__